import { Pipe, PipeTransform } from '@angular/core';
import { StudyListItem } from 'src/app/models/Study/study.model';

@Pipe({
  name: 'isSelectedStudies',
  pure: false,
})
export class IsSelectedStudiesPipe implements PipeTransform {
  transform(selectedItems: StudyListItem[], row: StudyListItem): any {
    return selectedItems.includes(row);
  }
}
